import { LANGUAGE_FLAGS, LANGUAGE_NAMES, type Locale } from '@/i18n'

// One row of the language list; `code` is what `language_code` is set to ('' = automatic, from Telegram).
export interface LanguageOption {
  code: Locale | ''
  selected: boolean
  name?: string // (native name; the automatic row has an i18n label and the Telegram icon instead)
  flag?: string
}

// The automatic row first, then the languages in the picker order, with the one in `chosen` marked.
export function languageOptions(chosen: string | null): LanguageOption[] {
  const languages = (Object.keys(LANGUAGE_NAMES) as Locale[]).map((code) => ({
    code,
    selected: chosen === code,
    name: LANGUAGE_NAMES[code],
    flag: LANGUAGE_FLAGS[code],
  }))
  return [{ code: '', selected: !chosen }, ...languages]
}
